<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 class="p-d-flex p-ai-baseline">
                    <span>
                        <router-link v-if="client && client.key" :to="{ name: 'sites', params: { id: client.key } }">{{
                            client.name
                        }}</router-link> /
                        Site Bin
                    </span>
                </h4>
                <!-- <p>Description of client.</p> -->
                <DataTable :value="deletedSites" :paginator="true" class="p-mb-4" :rows="10" dataKey="key"
                    :filters="filters" :loading="loading" sortField="name" :sortOrder="1">
                    <template #header>
                        <div class="p-d-md-flex p-jc-md-between">
                            List of Sites
                            <div>
                                <Button label="Delete Selected" icon="pi pi-trash" @click="openConfirmation"
                                    class="p-button-danger" v-if="selectedRows.length" />
                                <span class="p-input-icon-left p-mt-2 p-ml-md-2">
                                    <i class="pi pi-search" />
                                    <InputText v-model="filters['global'].value" placeholder="Site Search" />
                                </span>
                            </div>
                        </div>
                    </template>
                    <template #empty>
                        No sites found.
                    </template>
                    <template #loading>
                        Loading sites data. Please wait.
                    </template>
                    <Column field="metadata.name" header="Name" :sortable="true">
                        <template #body="slotProps">
                            <span>
                                {{ slotProps.data.metadata.name }}
                            </span>
                        </template>
                    </Column>
                    <Column headerClass="table__button--header" bodyClass="table__button">
                        <template #body="slotProps">
                            <Button icon="pi pi-history" class="p-button-primary" style="width: max-content;"
                                @click="restoreSite(slotProps.data.metadata.key, slotProps.data.metadata)"
                                label="Restore Site"></Button>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import { db } from '@/firebase';
import { mapGetters } from "vuex";
import { FilterMatchMode } from 'primevue/api';

export default {
    data() {
        return {
            selectedRows: [],
            filters: { 
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                'metadata.name': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            loading: true,
            deletedSites: [],
            client: {},
            displayConfirmation: false,
        }
    },
    firestore() {
        return {
            client: db.collection('clients').doc(this.$route.params.client_id),
            deletedSites: {
                ref: db.collection('site_bin').where('metadata.client_id', '==', this.$route.params.client_id),
                resolve: () => {
                    this.loading = false
                }
            },
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        })
    },
    methods: {
        restoreSite(siteKey, metadata) { // leaving this one-by-one for reduced user error
            db.collection('sites').doc(siteKey).set(metadata).then(() => {
                db.collection('site_bin').doc(siteKey).delete().then(() => {
                    db.collection('logs').add({
                        activity: 'Site Restored',
                        timestamp: new Date(),
                        user: this.user.data.email,
                        client_id: this.$route.params.client_id,
                        site: metadata.name
                    }).then(() => {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Site Restored', life: 3000 });
                    });
                })
            })
        },
    }
}
</script>
